// @ts-check
import PenIcon from "../../../../assets/icons/Pen";
import PlusIcon from "../../../../assets/icons/Plus";
import PushBackIcon from "../../../../assets/icons/PushBackIcon";
import { DropOptions } from "../dropOptions";
import { ContentTitle } from "./styles";

/**
 * @param {{
 *  handleCollapse: () => void,
 *  collapses: boolean,
 *  title: string,
 *  options?: Array<{ label: string, onClick: () => void }>
 *  onAddClick?: () => void,
 *  userPermissions: {
 *    canEdit: boolean,
 *    canDelete: boolean,
 *    canAdd: boolean
 * },
 *  }} props
 * @return {JSX.Element}
 */
export function Title({
  handleCollapse,
  collapses,
  title,
  options,
  onAddClick,
  userPermissions,
}) {
  return (
    <ContentTitle>
      <div className="title">
        <PenIcon width={20} height={20} onClick={() => {}} />
        <span>{title}</span>
      </div>
      <div className="click-bar" onClick={handleCollapse} />
      <div className="end-buttons">
        {onAddClick && userPermissions.canAdd && (
          <button className="add-button" onClick={onAddClick}>
            <PlusIcon />
          </button>
        )}
        {options && <DropOptions options={options} />}

        <button
          onClick={handleCollapse}
          style={{
            border: "none",
            background: "none",
          }}
        >
          <PushBackIcon
            width={20}
            height={20}
            onClick={() => {}}
            style={{
              transition: "transform 0.3s",
              transform: collapses ? "rotate(90deg)" : "rotate(270deg)",
            }}
            stroke="#111"
          />
        </button>
      </div>
    </ContentTitle>
  );
}
